import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import Title from '../../components/Title';
import CheckAuth from '../../components/CheckAuth';
import DashboardNavigationDrawer from './DashboardNavigationDrawer';

const DashboardLayout = () => {
    return (
        <CheckAuth>
            <Box
                sx={{
                    p: 0,
                    m: 0,
                    height: '100vh',
                    position: 'relative',
                    w: 1,
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <Title title='Admin' />
                <DashboardNavigationDrawer>
                    <Box component='main' sx={{ width: '100%', flexGrow: 1, p: { xs: 0, sm: 1 } }}>
                        <Outlet />
                    </Box>
                </DashboardNavigationDrawer>
            </Box>
        </CheckAuth>
    );
};

export default DashboardLayout;
